export type GovTransactionSide = 'buy' | 'sell';

const BUY_TOKENS = new Set(['P', 'PURCHASE']);
const SELL_TOKENS = new Set(['S', 'SALE']);

const firstToken = (value: string): string => value.trim().split(/\s+/)[0]?.toUpperCase() ?? '';

export const govTransactionSide = (value?: string | null): GovTransactionSide | null => {
  const token = firstToken(value ?? '');
  if (BUY_TOKENS.has(token)) return 'buy';
  if (SELL_TOKENS.has(token)) return 'sell';
  return null;
};

/** Format a gov-trades transaction code (e.g. "P (Partial)") into a readable label. */
export const formatTransaction = (value: string): string => {
  if (!value) return '';
  const trimmed = value.trim();
  const side = govTransactionSide(trimmed);
  if (!side) return trimmed;
  const [, ...rest] = trimmed.split(/\s+/);
  const type = side === 'buy' ? 'Purchase' : 'Sale';
  return rest.length ? `${type} ${rest.join(' ')}` : type;
};
